export enum PageHelpRoutes {
  APPLICATIONS = '/management/manage-applications/applications',
  NOMINATIONS = '/management/manage-nominations/nominations',
  REPORTING = '/management/reporting',
  PAYMENT_PROCESSING = '/management/payment-processing/available',
  SYSTEM_EMAILS = '/management/configure/system-emails',
  PROGRAM_SETUP_GRANT_PROGRAMS = '/management/program-setup/programs/all',
  PROGRAM_SETUP_CUSTOM_FORMS = '/management/program-setup/forms/all',
  PROGRAM_SETUP_NOMINATION_PROGRAMS = '/management/program-setup/nomination-programs/all',
  PROGRAM_SETUP_BUDGETS = '/management/program-setup/budgets/open',
  PROGRAM_SETUP_FUNDING_SOURCES = '/management/program-setup/funding-sources/open',
  PROGRAM_SETUP_WORKFLOWS = '/management/program-setup/workflows',
}

export interface PageHelpInfoFromApi {
  tourKey: string;
  dateCompleted: string;
}

export type PageHelpMap = Record<string, boolean>;

